/**
 * Task 2 — the one language Player AI responds in, fixed by the core prompt
 * whatever a message or document is written in. Settings → Player AI and the
 * rail's Player AI settings both show this same single choice; further
 * languages are future work.
 */
export const PLAYER_AI_LANGUAGE = "en";

export const PLAYER_AI_LANGUAGE_OPTIONS = [
  { value: PLAYER_AI_LANGUAGE, label: "English" },
];
